export default "__VITE_ASSET__C0gJzet5__"